import PropTypes from 'prop-types';
import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/styles';


const useStyles = makeStyles(() => ({
  formControl: {
    marginTop: 20,
    width: '100%'
  },
}));

const SelectField = ({
   children, disabled, id, label, style,
   input: { name, value, onChange },
   meta: { touched, error, warning },
   ...restProps
}) => {
  const classes = useStyles();

  return (
    <FormControl className={style || classes.formControl} error={!!(touched && error)} disabled={disabled || false}>
      <InputLabel htmlFor={id}>{label}</InputLabel>

      <Select
        value={value}
        onChange={onChange}
        inputProps={{
          name: name,
          id: id,
        }}
        {...restProps}
      >
        {children && children}
      </Select>

      {(touched && error) && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

SelectField.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any,
  }).isRequired,
  label: PropTypes.string.isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool.isRequired,
    warning: PropTypes.string,
  }).isRequired,
};

export default SelectField;
